module.exports = __webpack_public_path__ + "img/thumbnail_JapaneseRaccoonDog_j_normal.922c8252.png";